module.exports = "<symbol id=\"tt-icon-video\" viewBox=\"0 0 24 24\"><path d=\"M23.1 3.28a2.18 2.18 0 0 0-1.63-.72H2.53a2.18 2.18 0 0 0-1.63.72 2.29 2.29 0 0 0-.7 1.66v14.12a2.29 2.29 0 0 0 .7 1.66 2.18 2.18 0 0 0 1.63.72h18.94a2.18 2.18 0 0 0 1.63-.72 2.29 2.29 0 0 0 .7-1.66V4.94a2.29 2.29 0 0 0-.7-1.66zM8.46 16.93V7.4l9.44 4.81z\" xmlns=\"http://www.w3.org/2000/svg\"/></symbol>"


//////////////////
// WEBPACK FOOTER
// ./src/build/KmHgiPlfcrGbDfYsite/assets/svg/pdp-page/video.svg
// module id = 232
// module chunks = 9